import React from 'react'
import PropTypes from 'prop-types'

import { GlgLoadingSpinner } from 'SharedComponents'
import LeaguesTableContainer from '../containers/leagues_table_container'
import CategoriesListContainer from '../containers/categories_list_container'
import CalendarViewSimGolf from './sim_golf/calendar_view_component_sim_golf'
import LeaguesTableContainerSimGolf from '../containers/sim_golf/leagues_table_container_sim_golf'
import CategoriesListContainerSimGolf from '../containers/sim_golf/category_list_container_sim_golf'

const  CustomerCenterContentComponent = (props) => {
  const handleScroll = (e) => {
    const currentScrollAmount = Math.round(e.target.scrollHeight - e.target.scrollTop)
    const currentScrollPosition =
      currentScrollAmount <= e.target.clientHeight
        ? e.target.clientHeight
        : currentScrollAmount
    const marginError = e.target.clientHeight / 100
    const bottom = currentScrollPosition >= (e.target.clientHeight - marginError) && currentScrollPosition <= (e.target.clientHeight + marginError)

    if (bottom) {
      props.addLeaguesWithPagination()
    }
  }

  if (props.dataIsLoading) {
    return (
      <GlgLoadingSpinner className='add-margin-top-20' />
    )
  } else if (props.viewType === 'category') {
      return props.isSimGolf ? <CategoriesListContainerSimGolf /> : <CategoriesListContainer />
  } else {
    let viewContent

    if (props.isSimGolf) {
      viewContent =
          <div className={`list_container ${window.innerWidth <= 992 && 'list_container_responsive'}`} onScroll={ handleScroll }>
            { props.viewType === 'list' &&
              <LeaguesTableContainerSimGolf leagues={ props.leagues } />
            }
            { props.viewType === 'calendar' &&
              <CalendarViewSimGolf />
            }
          </div>
    } else {
      viewContent =
        <div className='add-margin-top-10'>
          <div className='categories_list_container' onScroll={ handleScroll }>
            <LeaguesTableContainer includeCategoryColumn={ true } />
          </div>
        </div>
    }

    return viewContent
  }
}

CustomerCenterContentComponent.propTypes = {
  viewType: PropTypes.string.isRequired,
  dataIsLoading: PropTypes.bool.isRequired,
  isSalesDemo: PropTypes.bool,
  addLeaguesWithPagination: PropTypes.func,
}

export default CustomerCenterContentComponent